import React from 'react';

const Contact = () => (
  <div className="container" style={{ minHeight: '60vh', paddingTop: '120px' }}>
    <h1>Contact Us</h1>
    <p>Contact form goes here</p>
  </div>
);

export default Contact;
